import './index.css';

import SimpleList, {
  SIMPLE_LIST_DEFAULT_ICON,
  SimpleListItem,
  SimpleListProps,
  SimpleListSize,
} from './simpleList';

export {
  SimpleList,
  SIMPLE_LIST_DEFAULT_ICON,
  SimpleListItem,
  SimpleListProps,
  SimpleListSize,
};
